import type { StorefrontBootstrap } from "@emynor/storefront-sdk";

type OnlineOrderType = "delivery" | "pickup" | undefined;

export type MainMenuDestination =
  "/main-menu" | "/branchMenu" | "/menu" | "/order-type";

const enabled = (
  bootstrap: StorefrontBootstrap,
  feature: keyof StorefrontBootstrap["features"],
) => bootstrap.features[feature]?.enabledForCustomers === true;

export function orderingModeAvailability(bootstrap: StorefrontBootstrap) {
  const asap = enabled(bootstrap, "asap_ordering");
  const delivery = enabled(bootstrap, "delivery") && asap;
  const pickup =
    enabled(bootstrap, "pickup") &&
    (asap || enabled(bootstrap, "scheduled_pickup"));

  return {
    delivery,
    pickup,
    online: delivery || pickup,
    dineIn: enabled(bootstrap, "dine_in_catalogue"),
  };
}

export function onlineOrderDestination(
  bootstrap: StorefrontBootstrap,
  orderType: OnlineOrderType,
): "/menu" | "/order-type" {
  const modes = orderingModeAvailability(bootstrap);
  const selectionIsAvailable =
    (orderType === "delivery" && modes.delivery) ||
    (orderType === "pickup" && modes.pickup);
  return selectionIsAvailable ? "/menu" : "/order-type";
}

export function mainMenuDestination(
  bootstrap: StorefrontBootstrap,
  orderType: OnlineOrderType,
): MainMenuDestination {
  const modes = orderingModeAvailability(bootstrap);
  if (modes.dineIn && modes.online) return "/main-menu";
  if (modes.online) return onlineOrderDestination(bootstrap, orderType);
  if (modes.dineIn) return "/branchMenu";
  return "/main-menu";
}
